import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import i18n from '../../Shared/Translation/i18n';
import { ApiUrl } from '../../project/Defines.js';
import { dispatchCustomEvent, EVENT_NAME } from '../../project/utilities';
import DetailView from '../../Shared/DetailView';
import useDetail from '../../Shared/useDetail';
import InputCont from '../../Shared/Form/InputCont';
import { connect } from 'react-redux';

const listUpdateEvent = EVENT_NAME.INFORMATION_LIST_UPDATE;

/**
 * Detail view for Information entries (Thercodim only).
 * Type = 'url'  → url field
 * Type = 'html' → title + html content (SunEditor)
 * @exports InformationDetails
 */
function InformationDetails(props) {
    const { windowKey, data, network } = props;
    const { id } = useParams();

    const { dataItem, setDataItem, updateData, hasChanges, closePopup, detailRef, onChangeData, validation } = useDetail({
        data: data || { ID: id !== "create" ? id : 0 },
        windowKey,
        updateUrl: ApiUrl.InformationUpdate,
        dataLoadUrl: ApiUrl.InformationLoad,
        deleteUrl: ApiUrl.InformationDelete,
        nameField: 'type',
        listUpdateEvent,
        validationFields: ['type'],
        additionalData: { salesNetworkId: +network || 0 },
    });

    const updateSuccessCallback = useCallback((response) => {
        if (detailRef.current) {
            setDataItem(response);
            dispatchCustomEvent(listUpdateEvent, { action: 'update' });
            closePopup();
        }
    }, [setDataItem, detailRef, listUpdateEvent, closePopup]);

    return (<>
        {dataItem && <DetailView hasChanges={hasChanges}>
            <view>
                <div className="form_container">
                    <div className="section_group">
                        <div className="sections" style={{ width: 650, height: 400 }}>
                            <InputCont
                                label='text.type'
                                inputProps={{
                                    validation,
                                    type: 'select',
                                    name: 'type',
                                    value: dataItem.type,
                                    onChange: (val) => onChangeData({ target: { name: 'type', value: val } }),
                                    items: [
                                        { value: 'url', text: 'URL' },
                                        { value: 'html', text: 'HTML' }
                                    ]
                                }}
                            />
                            {dataItem.type === 'url' && (
                                <InputCont
                                    label='text.url'
                                    inputProps={{
                                        name: 'url',
                                        value: dataItem.url || '',
                                        onChange: onChangeData,
                                        maxLength: '2000'
                                    }}
                                />
                            )}
                            {dataItem.type === 'html' && (<>
                                <InputCont
                                    label='text.title'
                                    inputProps={{
                                        name: 'title',
                                        value: dataItem.title || '',
                                        onChange: onChangeData,
                                        maxLength: '500'
                                    }}
                                />
                                <InputCont
                                    label='text.content'
                                    type="textarea"
                                    // height={400}

                                    inputProps={{
                                        name: 'content',
                                        value: dataItem.content || '',
                                        onChange: onChangeData,
                                        maxLength: '1000',
                                        type: 'textarea',
                                        style: { height: 250 }
                                    }}
                                />
                            </>)}
                        </div>
                    </div>
                </div>
                <toolbar>
                    <wrap>
                        <action right=''>
                            <div
                                onClick={() => updateData(updateSuccessCallback)}
                                className={hasChanges ? 'button primary' : 'button'}
                                disabled={validation?.isValid ? false : true}
                            >
                                <icon>save</icon>{i18n('text.save')}
                            </div>
                        </action>
                    </wrap>
                </toolbar>
            </view>
        </DetailView>}
    </>);
}

export default connect(state => ({ network: state.network }))(InformationDetails);